import * as React from 'react';
import { Field, reduxForm, change } from 'redux-form';

import { Text, Label, Item, Input, Toast, Form, View, Content, Button, H3 } from 'native-base';

import { textInput, numberInput } from './renderedComponents';
import customValidate from './validators';

function syncValidate(values, props) {
	//runs while field changing
	let errors = {};

	if (values.new_pin && values.confirm != values.new_pin) errors.confirm = 'No match';
	if (values.new_pin && values.new_pin.length == 0) errors.new_pin = 'Need PIN'; //should not see this!
	if (values.code && values.code.length != 6) errors.code = '6-digit code send by SMS';

	return errors;
}

class newPinForm extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {};
		this.state = this.initialState;
	}

	nextField(name) {
		this.refs[name] && this.refs[name].getRenderedComponent().refs.input._root.focus();
	}

	render() {
		const { handleSubmit, pristine, reset, submitting, partNo, invalid, reason } = this.props;
		this.formRefs = [];
		const { focus } = this.state;

		return (
			<View style={{ flex: 1 }}>
				<Content padder keyboardShouldPersistTaps={'handled'}>
					<Form onSubmit={this.props.handleSubmit} style={{ marginBottom: 10 }}>
						{reason == 'forgot' ? (
							<View style={{ flex: 1 }}>
								<Label>A one-time code has been sent by text message to the phone number ending {partNo}</Label>
								<Field
									name="code"
									labelWidth={180}
									label="One-time code received"
									component={textInput}
									returnKeyType={'next'}
									autoFocus
									maxLength={6}
									keyboardType="numeric"
									onEnter={() => this.nextField('pin')}
								/>
							</View>
						) : (
							<>
								{reason == 'temp' && (
									<>
										<H3>Welcome to CalCal</H3>
										<Label>Please enter your temporary PIN. We sent it to the phone number you signed up with</Label>

										<Button transparent onPress={() => this.props.navigation.navigate({ name: 'Pin', params: { change: 'forgot', backToPin: true } })}>
											<Text>Not received?</Text>
										</Button>
									</>
								)}
								{reason == 'change' && <Label>Use your current PIN to change your PIN</Label>}
								<Field
									name="current_pin"
									label={reason == 'temp' ? 'Temporary PIN' : 'Current PIN'}
									component={textInput}
									secureTextEntry={reason != 'temp'}
									labelWidth={150}
									returnKeyType={'next'}
									validate={[customValidate]}
									autoFocus
									maxLength={6}
									keyboardType="numeric"
									blurOnSubmit={false}
									onEnter={() => this.nextField('pin')}
								/>
							</>
						)}
						<Field
							name="new_pin"
							label="New PIN"
							secureTextEntry
							labelWidth={150}
							component={textInput}
							returnKeyType={'next'}
							keyboardType="numeric"
							ref={'pin'}
							forwardRef
							maxLength={6}
							blurOnSubmit={false}
							validate={[customValidate]}
							onEnter={() => this.nextField('code')}
						/>

						<Field
							name="confirm"
							label="Confirm"
							secureTextEntry
							component={textInput}
							labelWidth={150}
							keyboardType="numeric"
							maxLength={6}
							ref={'code'}
							forwardRef
							onEnter={() => this.props.handleSubmit()}
						/>
					</Form>
					<Button padder full disabled={invalid || submitting || pristine} onPress={this.props.handleSubmit}>
						<Text>Submit</Text>
					</Button>
				</Content>
			</View>
		);
	}
}

export default reduxForm({
	form: 'newPinForm',
	validate: syncValidate
})(newPinForm);
